import { FC, useCallback, memo } from 'react';
import { useWebSocket } from 'src/hooks/useWebSocket';

interface CertificationWebSocketProps {
  certificationID: number;
}

/**
 * WebSocket connection wrapper for a single certification
 * Memoized to prevent reconnections when parent re-renders
 */
const CertificationWebSocket: FC<CertificationWebSocketProps> = memo(
  ({ certificationID }) => {
    // Memoize handler so it doesn't change on re-renders
    const genericHandler = useCallback(
      (eventType: string, data: unknown): void => {
        const event = new CustomEvent('CertificationWebSocketEvent', {
          detail: { data, type: eventType },
        });
        document.dispatchEvent(event);
      },
      []
    );

    useWebSocket({
      enabled: Boolean(certificationID),
      url: `certification/${certificationID}/`,
      genericHandler,
      reconnectAttempts: 5,
      reconnectDelay: 3000,
    });
    return null;
  }
);

CertificationWebSocket.displayName = 'CertificationWebSocket';

export default CertificationWebSocket;
